export const NONE_FILTER_VALUE = '__NONE__';

/** None and named members are exclusive; honour whichever the user just selected. */
export function reportFilterSelection(previous: Array<string>, next: Array<string>): Array<string> {
  if (next.includes(NONE_FILTER_VALUE) && !previous.includes(NONE_FILTER_VALUE)) {
    return [NONE_FILTER_VALUE];
  }
  return next.length > 1 ? next.filter((value) => value !== NONE_FILTER_VALUE) : next;
}
